export enum UserRoles {
  superAdmin = "super-admin",
  owner = "owner",
  admin = "admin",
  user = "user"
}

export enum ScreenArtboardScrollDirection {
  vertical = "vertical",
  horizontal = "horizontal",
  noscroll = "noscroll"
}

export enum EventRecurrences {
  weekly = "weekly",
  monthly = "monthly",
  yearly = "yearly"
}

export enum ZmanimDisplayOverrideRoundTo {
  high = "round to high",
  closer = "round to closer",
  lower = "round to lower"
}

export enum TICKET_STATUSES {
    'open',
    'closed'
}

export enum TICKET_COMMENT_TYPES {
    'ticket-close',
    'ticket-reopen',
    'ticket-comment'
}

export enum KabbalahStatus_N {
  pending = "pending",
  approved = "approved",
  rejected = "rejected"
}

// How long the kabbalos were accepted for. The two fixed answers carry their
// own length; `custom` is the one that reads `Kabbalah_N.customDays`.
export enum KabbalahDuration_N {
  oneYear = "oneYear",
  fortyDays = "fortyDays",
  custom = "custom"
}
